// extracted by mini-css-extract-plugin
module.exports = {"title":"ConfirmDialog_title__1rxTa","actions":"ConfirmDialog_actions__3z4XO","action-button":"ConfirmDialog_action-button__2nMR6"};